import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import React from 'react';
import { CommonElementProps } from '../types';
import ElementUtils from '../utils';

export type CheckboxOption<T, V> = {
  label: T;
  value: V;
};

export interface CheckboxGroupProps<T, V> extends CommonElementProps<V[]> {
  options: CheckboxOption<T, V>[];
  value?: V[];
  onChange?: (value: V[]) => void;
}

const CheckboxGroup = function CheckboxGroup
  <T, V>(props: CheckboxGroupProps<T, V>) {
  const {
    options,
    value: checkedValues,
    onChange,
    label,
    error,
  } = props;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, isChecked: boolean) => {
    const newValue = checkedValues ? [...checkedValues] : [];
    if (isChecked) {
      newValue.push(+event.target.value as V);
      if (onChange) {
        onChange(newValue);
      }
    } else {
      const currentValue = +event.target.value as V;
      const currentValues = newValue.filter((val) => val !== currentValue);
      if (onChange) {
        onChange(currentValues);
      }
    }
  };

  return (
    <div>
      <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
        <div>{label}</div>
        <FormGroup className="grid grid-cols-2 gap-x-6 gap-y-2">
          {options.map((option) => {
            const { value, label: optionLabel } = option;
            const isChecked = checkedValues?.includes(value);
            return (
              <FormControlLabel
                control={
                  (
                    <Checkbox
                      value={value}
                      checked={isChecked}
                      onChange={handleChange}
                      name={optionLabel as string}
                    />
                  )
                }
                label={optionLabel as string}
              />
            );
          })}
        </FormGroup>
        {error && (
          <div className="absolute -bottom-5 text-error text-xs">
            {ElementUtils.renderError(error)}
          </div>
        )}
      </FormControl>
    </div>
  );
};

CheckboxGroup.defaultProps = {
  value: [],
  onChange: () => { },
};

CheckboxGroup.propTypes = {

};
export default CheckboxGroup;
